<template>
    <div>
        <v-container fluid class="pt-10">
            <v-row justify="center"
                   v-for="(item,index) in configList"
                   :key="index"
                   align="center">
                <v-col cols="2"
                       class="text-center font-weight-bold">
                    {{item.paramName}}：
                </v-col>
                <v-col cols="6">
                    <v-textarea
                            filled
                            name="input-7-4"
                            clearable
                            label=""
                            v-model="item.val"
                    ></v-textarea>
                </v-col>
                <v-col cols="2"
                       class="text-center">
                    <v-btn color="primary" @click="update(item)">确认更新</v-btn>
                </v-col>
            </v-row>
        </v-container>

        <!--loading组件 start-->
        <z-loading v-model="isShowLoading"></z-loading>
        <!--loading组件 end-->


        <z-notify ref="notify" ></z-notify>

        <!--<div class="typeListView"-->
             <!--draggable="false"-->
             <!--ref="typeListView">-->
            <!--<div class="photos"-->
                 <!--ref="album">-->
                <!--<div class="photo">1</div>-->
                <!--<div class="photo">2</div>-->
                <!--<div class="photo">3</div>-->
                <!--<div class="photo">4</div>-->
                <!--<div class="photo">1</div>-->
                <!--<div class="photo">2</div>-->
                <!--<div class="photo">3</div>-->
                <!--<div class="photo">4</div>-->
            <!--</div>-->
        <!--</div>-->


    </div>
</template>

<script>
  import {
    update,
    paramConfigDetail
  } from '@/api/parameterConfige'

  export default {
    name: 'ParameterConfig',
    data() {
      return {
        msg: '',
        isShowLoading: false,
        configList: [],
      }
    },
    mounted() {
      this.queryConfigDetail();
      // this.rotate();
    },
    methods: {
      returnFalse(e) {
        e.preventDefault();
      },
      rotate() {
        var album = this.$refs.album;
        var imgs = this.$refs.album.children;
        var len = imgs.length;
        var newX, newY, lastX, lastY, minusX, minusY;
        var rotX = 0;
        var rotY = 0;
        var initClientX = '';
        var endClientX = '';
        var _this = this;
        this.time = 0;
        this.unitDeg = 360 / len
        _this.opacityList = [];

        var stepOpacity = 1 / (len / 4);
        for (var i = 0; i < len; i++) {
          if (i <= len / 4) {
            _this.opacityList.push(1 - i * stepOpacity);
          } else if (i >= (len - len / 4)) {
            _this.opacityList.push(1 - (len - i) * stepOpacity);
          } else {
            _this.opacityList.push(0);
          }
        }
        console.log(_this.opacityList, '_this.opacityList');
        this.$nextTick(() => {
          Array.prototype.forEach.call(imgs, (it, i, arr) => {

            it.style.transform = `rotateY(${i * _this.unitDeg}deg) translateZ(350px)`;
            it.style.opacity = `${_this.opacityList[i]}`;

            it.onmousedown = this.returnFalse
          })

          album.style.transform = `rotateX(-11deg) rotateY(0deg)`;

          //   鼠标移动 相册旋转 改变album的transform 的rotateX 和 rotateY的值
          document.getElementsByClassName('typeListView')[0].onmousedown = function (e) { // 鼠标点击事件
            initClientX = e.clientX;
            lastX = e.clientX
            lastY = e.clientY
            this.onmousemove = (e) => { // 鼠标移动事件
              newX = e.clientX
              newY = e.clientY
              // 假设 并求值 两次鼠标移动的差值就是移动的距离 和相册旋转的角度成正比
              minusX = newX - lastX
              minusY = newY - lastY
              // 新的值用完之后就成了旧的值
              lastX = newX
              lastY = newY
            }
            this.onmouseup = (e) => { // 鼠标松开事件
              _this.isAll = false;
              endClientX = e.clientX;
              if (Math.abs(initClientX - endClientX) < 5) {
                // 点击事件
              } else {
                minusX > 0 ? _this.time++ : _this.time--;
                album.style.transform = `rotateX(-11deg) rotateY(${_this.unitDeg * _this.time}deg)`;
                if (minusX > 0) {
                  _this.opacityList = _this.opacityList.slice(1, _this.opacityList.length).concat(_this.opacityList[0]);
                } else {
                  _this.opacityList = _this.opacityList.slice(_this.opacityList.length - 1, _this.opacityList.length).concat(_this.opacityList.slice(0, _this.opacityList.length - 1));
                }
                Array.prototype.forEach.call(imgs, (it, i, arr) => {
                  it.style.opacity = `${_this.opacityList[i]}`;
                })
              }
              this.onmousemove = null;
            }
          }
        })
      },
      update(item) {
        // console.log(item,'item88888888');
        // console.log(this.configList,'item999999999');

        var reqData = {
          type: item.type,
          val: item.val
        };
        this.isShowLoading = true;
        update(reqData).then(res => {
          this.isShowLoading = false;
          this.$refs.notify.show("修改成功", {timeout: 1000, color: 'green'});
          this.queryConfigDetail();
        }).catch(err => {
          this.isShowLoading = false;
        });
      },
      // 查询业务配置配置
      queryConfigDetail() {
        this.isShowLoading = true;
        paramConfigDetail({}).then(res => {
          this.isShowLoading = false;
          this.configList = res;
        }).catch(err => {
          this.isShowLoading = false;
        });
      },
    }
  }
</script>

<style scoped>

    .typeListView {
        perspective: 800px;
    }

    .typeListView .photos {
        position: relative;
        width: 100px;
        height: 100px;
        margin: 150px auto;
        transform-style: preserve-3d; /*设置3d风格*/
        transform: rotateX(-8deg) rotateY(0deg);
    }

    .typeListView .photos .photo {
        display: inline-block;
        position: absolute;
        width: 100px;
        height: 100px;
        border: 1px solid #fff;
        background-color: #ccccff;
        transition: 1s;
    }
</style>